import { Navigate, useParams } from "react-router-dom";

/**
 * Form create/edit pages were converted to pop-up modals opened from their list
 * page. The old `/create` and `/:id/edit` routes are kept as thin redirects so
 * existing bookmarks / deep links still work: they bounce to the list page with
 * a query param the list reads on mount to auto-open the modal.
 *
 *   /portal/admin/course-pillar/create     -> /portal/admin/course-pillars?create=1
 *   /portal/admin/course-pillar/5/edit     -> /portal/admin/course-pillars?edit=5
 */

export function CreateRedirect({ to }: { to: string }) {
  const sep = to.includes("?") ? "&" : "?";
  return <Navigate to={`${to}${sep}create=1`} replace />;
}

export function EditRedirect({ to }: { to: string }) {
  const { id } = useParams();
  const sep = to.includes("?") ? "&" : "?";
  return <Navigate to={`${to}${sep}edit=${id ?? ""}`} replace />;
}
